import React from 'react';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Toaster } from 'sonner';

import './locales/i18n';
import GlobalStyles from './assets/styles/global';
import theme from './assets/styles/theme';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './routes';
import history from './routes/history';

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Router history={history}>
            <GlobalStyles />
            <Toaster position="top-right" richColors />
            <Routes />
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
